const envServerUrl = import.meta.env.VITE_SERVERURL;
const envDriverUrl = import.meta.env.VITE_DRIVERURL;

function resolveServerUrl(): string {
  if (
    envServerUrl &&
    typeof envServerUrl === "string" &&
    envServerUrl.trim() !== ""
  ) {
    return envServerUrl.replace(/\/+$/, "");
  }
  if (typeof window !== "undefined" && window.location) {
    const host = window.location.hostname;
    if (host.includes("dev.autopilotqa.com")) {
      return `https://${host.replace("dev.", "dev-api.")}`;
    }
    if (host.includes("autopilotqa.com")) {
      return "https://api.autopilotqa.com";
    }
  }
  return "http://localhost:9090";
}

const resolvedServerUrl = resolveServerUrl();

const EnvConfig = {
  baseURL:
    import.meta.env.VITE_BASEURL ||
    (typeof window !== "undefined" ? window.location.origin : ""),
  serverURL: resolvedServerUrl,
  basePath: import.meta.env.VITE_BASEPATH || "/",
  extensionURL: import.meta.env.VITE_EXTENSIONURL,
  driverURL:
    envDriverUrl &&
    typeof envDriverUrl === "string" &&
    envDriverUrl.trim() !== ""
      ? envDriverUrl.replace(/\/+$/, "")
      : resolvedServerUrl,
};

export default EnvConfig;
